import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Line,
  Rect,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Rect, { width: "7", height: "7", x: "3", y: "14", rx: "1", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Rect, { width: "7", height: "7", x: "3", y: "3", rx: "1", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "14", x2: "21", y1: "4", y2: "4", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "14", x2: "21", y1: "9", y2: "9", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "14", x2: "21", y1: "15", y2: "15", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "14", x2: "21", y1: "20", y2: "20", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "LayoutList";
const LayoutList = memo(themed(Icon));
export {
  LayoutList
};
//# sourceMappingURL=layout-list.js.map
